import { FieldCheck } from "./getFieldChecks";

/** Formik errors for submit: one message per unfilled field, keyed by `field_key` */
export const getFormErrors = (checks: FieldCheck[]): Record<string, string> =>
  Object.fromEntries(
    checks
      .filter(({ isFilled }) => !isFilled)
      .map(({ fieldKey, error }) => [fieldKey, error])
  );
